import React, { useState, useEffect, useCallback, startTransition } from "react";
import { Link, useNavigate } from "react-router-dom";
import { MyDiv, PTag } from "./Components";
import Avatar from "react-avatar";
import { RiUserHeartLine, RiLockPasswordLine, RiLogoutCircleLine } from "react-icons/ri";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import swal from "sweetalert2";

import { getRequest } from "./api/apiService";
import { addUserState, resetState } from "../ReduxToolkit/reducer/userReducer";

function Header() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector(state => state.user);

  const loadUser = useCallback(async () => {
    try {
      const userId = localStorage.getItem("userId");
      if (!userId) return;
      const url = `specificprofile/${userId}`;
      const response = await getRequest(url);
      if (response?.data?.length) {
        const { emp_firstName, emp_Designation } = response.data[0];
        dispatch(addUserState({ emp_firstName, emp_Designation }));
      }
    } catch (error) {
      console.error("Error loading user:", error);

      const message = error?.response?.data?.message || error?.response?.data || "Something went wrong. Please try again.";

      swal.fire({
        text: message,
        icon: "error",
      });
      if (message === "Invalid Token") {
        localStorage.removeItem("token");
        window.location.href = "/login";
      }
    }
  }, [dispatch]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const role = localStorage.getItem("role");

    if (!token || !role) {
      navigate("/login");
      return;
    }

    if (!user.emp_firstName) {
      loadUser();
    }
  }, [navigate, user.emp_firstName, loadUser]);

  const DateTime = () => {
    const [date, setDate] = useState(new Date());
    useEffect(() => {
      const timer = setInterval(() => setDate(new Date()), 1000);
      return () => clearInterval(timer);
    }, []);
    return (
      <MyDiv className="HeaderInfo hide-for-small">
        <span>
          {date.toLocaleDateString()}, {date.toLocaleTimeString()}
        </span>
      </MyDiv>
    );
  };

  const logoutCore = () => {
    startTransition(() => {
      localStorage.clear();
      dispatch(resetState());
      navigate("/login");
    });
  };

  const RolePermission = JSON.parse(localStorage.getItem("role"));

  return (
    <header>
      <Row>
        <Col xs={6} md={4}>
          <Link to="/dashboard">
            <img src={require("../../assets/images/logo.png")} alt="logo" />
          </Link>
        </Col>
        <Col xs={6} md={8} className="text-end right-menu">
          {RolePermission?.HighLevelAproval?.view === "1" && (
            <Link to="/audit" className="btn primary-btn me-2 hide">
              Audit
            </Link>
          )}
          <DateTime />
          <React.Fragment>
            <Avatar round="50px" size="40" name={user.emp_firstName || "U"} src="" />
            <MyDiv className="ProfileArea">
              <DropdownButton title={user.emp_firstName || "User"}>
                <Dropdown.Item as={Link} to="/changepassword">
                  <RiLockPasswordLine /> Change Password
                </Dropdown.Item>
                <Dropdown.Item as={Link} to="/profile">
                  <RiUserHeartLine /> My Profile
                </Dropdown.Item>
                <Dropdown.Item onClick={logoutCore}>
                  <RiLogoutCircleLine /> Logout
                </Dropdown.Item>
              </DropdownButton>
              {user.emp_Designation && <PTag className="hide-for-small">{user.emp_Designation}</PTag>}
            </MyDiv>
          </React.Fragment>
        </Col>
      </Row>
    </header>
  );
}

export default Header;
